import { actionTypes } from 'state/actions/authenticate';

const initialState = {
  valid_key: ""
};

const authenticate = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case actionTypes.SAVE_VALID_KEY:
      return {
        ...state,
        valid_key: payload
      };
    default:
      return state;
  }
};

export default authenticate;
